export const TEXT_BUTTON_INCREASE_INDENT = 'text-button-increase-indent';
export const TEXT_BUTTON_DECREASE_INDENT = 'text-button-decrease-indent';
